<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="false">

            <el-form-item class="form-title" prop="vc_name" label="名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_name" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" label="英文名称" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_ename" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_ename}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_sname" label="缩写" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_sname" size="mini" placeholder="请输入"></el-input>
                <div class="mrA" v-else>{{formData.vc_sname}}</div>
            </el-form-item>

            <el-form-item class="form-title" v-if="(data.data.i_id==0&&data.type=='add')||(data.data.i_level==0&&data.type=='edit')" prop="i_pid" label="所属大洲" style="width: 350px" required>
                <el-select v-model="formData.i_pid" @change="dzChange" size="mini" style="width:100%; "v-if="canEdit">
                    <el-option v-for="item in dzList" :key="item.i_id"  :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_continent}}</div>
            </el-form-item>

            <el-form-item prop="isuse" label="是否启用" style="width: 350px" v-if="data.type=='edit'">
                <el-radio-group v-model="formData.isuse" v-if="canEdit">
                    <el-radio  :label="1">是</el-radio>
                    <el-radio  :label="0">否</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.isuse==1?'是':'否'}}</div>
            </el-form-item>
<!--            <el-form-item class="form-title" prop="vc_lruname" label="录入人" style="width: 350px" >-->
<!--                <div class="mrA" >{{formData.vc_lruname}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="dt_createtime" label="录入时间" style="width: 350px" >-->
<!--                <div class="mrA" >{{formData.dt_createtime}}</div>-->
<!--            </el-form-item>-->
        </el-form>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">编辑</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";

    export default {
        name: "AddPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                formData:{
                    vc_name:'',
                    vc_ename:'',
                    isuse:1,
                    i_pid:0,
                },
                canEdit:false,
                disabled:false,
                dzList:[],
                rules:{
                    vc_name:[{required: true,message:'名称不能为空'}],
                    vc_ename:[{required: true,message:'英文名称不能为空'}],
                    i_pid:[{required: true,message:'大洲不能为空'}],

                    // isuse:[{required: true,message:'是否启用不能为空'}],
                }
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            // this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.type=='add'){
                this.canEdit=true;
                this.formData.i_pid=this.data.data.i_id
                if(this.data.data.i_id==0&&this.data.data.i_level==0){
                    this.getContinents()
                }
                // this.formData.i_pid=this.data.data.i_id
                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                this.formData=JSON.parse(JSON.stringify(this.data.data))
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                console.log(this.formData,'formData',formName)
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        if(this.data.type=='add'){
                            this.addArea()

                        }else{
                            this.editArea()
                        }
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.canEdit=true
                if(this.data.data.i_level==0){
                    this.getContinents()
                }

            },
            dzChange(val){
                // console.log(val)
                this.formData.i_pid=val
                this.formData.i_continent=val
                this.formData.vc_continent=this.dzList.find(dz=>dz.i_id==this.formData.i_pid).vc_name
                this.$forceUpdate()
            },
            //大洲
            async getContinents(){
                let param={
                };
                let res=await API.getContinents(param);
                if ( res.code == 1 ){
                    this.dzList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //新增
            async addArea(){
                this.disabled=true

                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                if(this.data.data.i_id==0&&this.data.data.i_level==0){
                    this.formData.i_level=0
                }else{
                    this.formData.i_level=this.data.data.i_level+1
                }
                let param=this.formData;
                let res=await API.addArea(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.disabled=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            //编辑
            async editArea(){
                this.disabled=true;
                // this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                // this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                // this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                let param=this.formData;
                let res=await API.editArea(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.disabled=false;
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }

</style>